import { DatePipe } from '@angular/common';
import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, NgForm, Validators } from '@angular/forms';
import { SearchInputDynamicComponent } from '@components/search-input-dynamic/search-input-dynamic.component';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Employee } from '@app/pages/admin/empleados/employee.model';
import { EmployeesService } from '@services/employees/employees.service';
import { DsconfigService, NotificationsService, ObservatoryService, StorageService, UserService } from '@services/services.module';
import { Subject, Subscription } from 'rxjs';
import { APP_URLS } from '@app/constants/app-urls';
import { ROL_TYPE } from '@app/constants/enums';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'formulario-empleado',
  templateUrl: './formulario-empleado.component.html',
  styleUrls: ['./formulario-empleado.component.scss']
})
export class FormularioEmpleadoComponent implements OnInit, OnDestroy {
  @ViewChild('searchInput') searchInput: SearchInputDynamicComponent;
  @Input() textButton = '';
  @Input() modelForm: Employee = {
    employeeId: null,
    addressEmployee: '',
    cityEmployee: '',
    costCenterId: null,
    emailEmployee: '',
    emailGoogleEmployee: '',
    endDateEmployee: '',
    externalEmployee: null,
    endDate: null,
    startDate: null,
    genderEmployee: null,
    groupId: null,
    mpwId: '',
    nameEmployee: '',
    numberStreetEmployee: '',
    observationsEmployee: '',
    officeCalendarId: null,
    officeId: 0,
    phoneMobileCompany: '',
    phoneMobilePrivate: '',
    postalCodeEmployee: null,
    profileEssId: 0,
    provinceEmployee: '',
    registerDateEmployee: '',
    responsibleEmployeeId: null,
    restAddressEmployee: '',
    sapId: '',
    shortPhoneMobile: '',
    streetEmployee: '',
    surnamesEmployee: '',
    intCatId: null,
    datEmpcatFechainicio: null,
    intJorId: null,
    datEmpJorFechaInicio: null,
    varEmpjorComentario: null,
    intDivId: null,
    birthEmployee: '',
    dateBirth: null,
    dniEmployee: '',
    rateEmployee: null
  };

  private subscriptions: Array<Subscription> = [];
  private employeId: number;
  private endDateStorage: Date;
  private staticSapId: string;
  private divisionModel: any = null;
  private responsables = [];
  private modelFormBeforeChangeIntExt = {};
  public APP_URLS = APP_URLS;
  public clearListEmployee: Subject<void> = new Subject<void>();
  public showValidatorError = true;
  public validatorCodeError = true;
  public showNumberError = true;
  public validatePhoneNumberError = true;
  public validateMpw = true;
  public availableButton = true;
  public nameValidator = true;
  public surnameValidator = true;
  public addressValidator = true;
  public numberAddressValidator = true;
  public restAddressValidator = true;
  public cityValidator = true;
  public mobileCompanyValidator = true;
  public shortPhoneValidator = true;
  public modelFormControlDisabled: any = {
    allLocked: false,
    endDate: true,
    startDate: false,
    intDivId: true,
    sapId: false,
    emailEmployee: false
  };
  public mostrarboton: boolean;
  public genders;
  public viaType;
  public province;
  public employeeType;
  public calendarios = [];
  public perfiles = [];
  public oficinas = [];
  public grupos = [];
  public categorias = [];
  public centrocostes = [];
  public divisiones = [];
  public email = [];
  public jornadas = [];
  public showIntExtButton = false;
  public listEmployee: any = [];
  public modelJornada = [];
  public modelNewWorkingDay: any = {
    intJorId: null,
    datEmpJorFechaInicio: null,
    fechaJorInicio: null,
    varEmpjorComentario: null
  };
  public modelCategoria = [];
  public modelNewCategory: any = {
    intCatId: null,
    fechaCatInicio: null,
    datEmpcatFechainicio: null
  };
  public panelJornada = false;
  public panelCategoria = false;
  public employe: any;
  public isOperationsTypeUser = false;

  public emailFormControl = new FormControl('', [
    Validators.required,
    Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$')
  ]);
  public gmailFormControl = new FormControl('', [
    Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$')
  ]);
  public postalCodeFormControl = new FormControl('', [
    Validators.minLength(5)
  ]);

  constructor(
    public translate: TranslateService,
    private dsConfig: DsconfigService,
    private employeesService: EmployeesService,
    private observatory: ObservatoryService,
    private storage: StorageService,
    private notification: NotificationsService,
    private datePipe: DatePipe,
    private _user: UserService
    ) {
    this.checkIfUserIsOperationType();
    this.getAllData();
    translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.genders = this.dsConfig.getGender();
      this.viaType = this.dsConfig.getVia();
      this.province = this.dsConfig.getProvince();
      this.employeeType = this.dsConfig.getEmployeeType();
    });
  }

  ngOnInit() {
    this.genders = this.dsConfig.getGender();
    this.viaType = this.dsConfig.getVia();
    this.province = this.dsConfig.getProvince();
    this.employeeType = this.dsConfig.getEmployeeType();
    this.resetFormulario(null);
    this.mostrarboton = false;
  }

  checkIfUserIsOperationType() {
    this._user.checkRolType([ROL_TYPE.operations]).then((data: any) => {
      if (data.value) {
        this.modelFormControlDisabled = {
          allLocked: true,
          endDate: true,
          startDate: true,
          intDivId: true,
          sapId: true,
          emailEmployee: true
        };
        this.isOperationsTypeUser = true;
      }
    });
  }

  validateCodeText($event) {
    this.validatorCodeError = $event;
    this.availableButton = $event;
  }

  validateDniCif($event) {
    this.showValidatorError = $event;
    this.availableButton = $event;
  }

  validateNumber($event) {
    this.showNumberError = $event;
    this.availableButton = $event;
  }

  validatePhoneNumber($event) {
    this.validatePhoneNumberError = $event;
    this.availableButton = $event;
  }

  validateMpwId($event) {
    this.validateMpw = $event;
    this.availableButton = $event;
  }

  validateName($event) {
    this.nameValidator = $event;
    this.availableButton = $event;
  }

  validateSurname($event) {
    this.surnameValidator = $event;
    this.availableButton = $event;
  }

  validateAddress($event) {
    this.addressValidator = $event;
    this.availableButton = $event;
  }

  validateNumberAddress($event) {
    this.numberAddressValidator = $event;
    this.availableButton = $event;
  }

  validateRestAddress($event) {
    this.restAddressValidator = $event;
    this.availableButton = $event;
  }

  validateCity($event) {
    this.cityValidator = $event;
    this.availableButton = $event;
  }

  validatePhoneMobile($event) {
    this.mobileCompanyValidator = $event;
    this.availableButton = $event;
  }

  validateShortPhone($event) {
    this.shortPhoneValidator = $event;
    this.availableButton = $event;
  }

  getAllData() {
    if (this.centrocostes.length === 0) {
      this.subscriptions.push(
        this.employeesService.getCostCenter().subscribe((data: any[]) => {
          if (data) {
            this.centrocostes = data;
          }
        })
      );
    }

    if (this.divisiones.length === 0) {
      this.subscriptions.push(
        this.employeesService.getDivisions().subscribe((data: any[]) => {
          if (data) {
            this.divisiones = data;
          }
        })
      );
    }

    if (this.jornadas.length === 0) {
      this.subscriptions.push(
        this.employeesService.getWorkingDays().subscribe((data: any[]) => {
          if (data) {
            this.jornadas = data;
          }
        })
      );
    }

    if (this.oficinas.length === 0) {
      this.subscriptions.push(
        this.employeesService.getOffices().subscribe((data: any[]) => {
          if (data) {
            this.oficinas = data;
          }
        }),
      );
    }

    if (this.perfiles.length === 0) {
      this.subscriptions.push(
        this.employeesService.getProfiles().subscribe((data: any[]) => {
          if (data) {
            this.perfiles = data;
          }
        }),
      );
    }

    if (this.calendarios.length === 0) {
      this.subscriptions.push(
        this.employeesService.getCalendars().subscribe((data: any[]) => {
          if (data) {
            this.calendarios = data;
          }
        }),
      );
    }

    if (this.categorias.length === 0) {
      this.subscriptions.push(
        this.employeesService.getCategories().subscribe((data: any[]) => {
          if (data) {
            this.categorias = data;
          }
        })
      );
    }
  }

  guardar(form: NgForm) {
    if (this.compareDates(this.modelForm.startDate, this.modelForm.endDate)) {
      const fechas = [
        { dateOne: this.modelForm.startDate },
        { dateTwo: this.modelForm.endDate },
        { dateBirth: this.modelForm.dateBirth },
      ];
      this.formatDates(fechas).then(
        (val: any) => {
          this.modelForm.endDateEmployee = val.dateTwo;
          this.modelForm.registerDateEmployee = val.dateOne;
          this.modelForm.birthEmployee = val.dateThree;
          if (this.modelForm.employeeId === null) {
            this.modelForm.datEmpcatFechainicio = val.dateOne;
            this.modelForm.datEmpJorFechaInicio = val.dateOne;
          } else {
            // gestionar las categorias
            if (this.modelNewCategory.intCatId !== null) {
              this.modelForm.intCatId = this.modelNewCategory.intCatId;
              const fechaCat = this.modelNewCategory.datEmpcatFechainicio;
              if (fechaCat) {
                this.modelForm.datEmpcatFechainicio = fechaCat.replace(/-/g, '');
              } else {
                this.modelForm.datEmpcatFechainicio = '';
              }
            } else {
              if (this.modelCategoria !== []) {
                const fechaCat = this.modelCategoria[this.modelCategoria.length - 1].datEmpcatFechainicio;
                if (fechaCat) {
                  this.modelForm.datEmpcatFechainicio = fechaCat.replace(/-/g, '');
                } else {
                  this.modelForm.datEmpcatFechainicio = '';
                }
              } else {
                this.modelForm.datEmpcatFechainicio = null;
              }
            }
            // gestionar las jornadas
            if (this.modelNewWorkingDay.intJorId !== null) {
              this.modelForm.intJorId = this.modelNewWorkingDay.intJorId;
              const fechaJor = this.modelNewWorkingDay.datEmpJorFechaInicio;
              this.modelForm.datEmpJorFechaInicio = fechaJor.replace(/-/g, '');
              this.modelForm.varEmpjorComentario = this.modelNewWorkingDay.varEmpjorComentario;
            } else {
              if (this.modelJornada !== []) {
                const fechaJor = this.modelJornada[this.modelJornada.length - 1].datEmpjorFechainicio;
                if (fechaJor) {
                  this.modelForm.datEmpJorFechaInicio = fechaJor.replace(/-/g, '');
                  this.modelForm.varEmpjorComentario = this.modelJornada[this.modelJornada.length - 1].varJorComentario;
                } else {
                  this.modelForm.datEmpJorFechaInicio = '';
                }
              } else {
                this.modelForm.datEmpJorFechaInicio = null;
                this.modelForm.varEmpjorComentario = null;
              }
            }
          }
          if (this.modelForm.rateEmployee !== null) {
            this.modelForm.rateEmployee = '' + this.modelForm.rateEmployee;
            this.modelForm.rateEmployee = this.modelForm.rateEmployee.trim();
            this.modelForm.rateEmployee = parseFloat(this.modelForm.rateEmployee).toFixed(2);
          } else {
            delete this.modelForm.rateEmployee;
          }

          window.scrollTo(0, 0);
          this.subscriptions.push(
            this.employeesService.addEmployee(this.modelForm).subscribe(data => {
              if (data.employeeId) {
                this.clearWorkingDay();
                this.clearCategory();
                this.notification.setSuccess(this.translate.instant('FORM_EMPLEADO.REGISTRO_OK'));
                this.takeEmployeData(data.emailEmployee);

                const value = this.modelForm.nameEmployee + ' ' + this.modelForm.surnamesEmployee;
                this.searchInput.value = value;
              }
              if (data.response === 'OK') {
                this.clearWorkingDay();
                this.clearCategory();
                this.notification.setSuccess(this.translate.instant('FORM_EMPLEADO.MODIFICACION_OK'));
                this.takeEmployeData(this.modelForm.emailEmployee);
              }
              if (data.response !== 'OK' && !data.employeeId) {
                this.notification.setWarning(this.translate.instant('ERRORS.' + data.response));
              }

            })
          );
        }, (err) => { });
    }
  }

  takeEmployeData(email) {
    this.subscriptions.push(
      this.employeesService.getAllEmployees().subscribe(listEmpData => {
        if (listEmpData) {
          this.listEmployee = listEmpData;
          this.storage.remove('listEmployee');
          this.listEmployee.sort(function (a, b) {
            if (a.nameEmployee < b.nameEmployee) { return -1; }
            if (a.nameEmployee > b.nameEmployee) { return 1; }
            return 0;
          });
          this.listEmployee.map(function (item) {
            item.campoCompleto = item.nameEmployee + ' ' + item.surnamesEmployee;
            item.Id = item.employeeId;
            return item;
          });
          this.storage.set('listEmployee', this.listEmployee);
          this.observatory.setData('updateList', null);
          const completeName = this.listEmployee.find(m => m.emailEmployee === email).nameEmployee + ' ' +
            this.listEmployee.find(m => m.emailEmployee === email).surnamesEmployee;
          const EmployeeAdded = {
            Id: this.listEmployee.find(m => m.emailEmployee === email).Id
            , name: completeName
          };


          // recaragmos la ista de clientes del searchInput
          this.searchInput.getList();

          this.takeEmploye(EmployeeAdded, null);
          // forzar eliminar el ultimo elemento buscado en el buscador
          this.observatory.setData('idItemList', EmployeeAdded);
        }
      })
    );
  }

  cancel(form: NgForm) {
    this.employeId = undefined;
    this.searchInput.value = '';
    this.searchInput.enableInput = false;
    this.resetFormulario(form);
    this.grupos = [];
    this.responsables = [];
    if (!this.isOperationsTypeUser) {
      this.modelFormControlDisabled.allLocked = false;
      this.modelFormControlDisabled.startDate = false;
      this.modelFormControlDisabled.intDivId = true;
      this.modelFormControlDisabled.sapId = false;
      this.modelFormControlDisabled.emailEmployee = false;
    }

    this.modelFormControlDisabled.endDate = true;

    this.textButton = this.translate.instant('CREMP');
    this.observatory.setData('textHeader', 'new');
    this.clearListEmployee.next();
  }

  formatDates(fechas) {
    // tslint:disable-next-line:no-shadowed-variable
    return new Promise((resolve, reject) => {
      let endMes = '';
      let endDay = '';
      let initMes = '';
      let initDay = '';
      let dateEnd;
      let dateInit;
      let dateThree;

      if (!!fechas.length) {
        fechas.forEach(element => {
          endMes = '';
          endDay = '';
          initMes = '';
          initDay = '';
          if (element.dateOne) {
            if (element.dateOne !== null && element.dateOne !== undefined) {
              if (element.dateOne.getDate() < 10) {
                initDay = '0' + element.dateOne.getDate();
              } else {
                initDay = '' + element.dateOne.getDate();
              }
              if (Number(element.dateOne.getMonth() + 1) < 10) {
                initMes = '0' + Number(element.dateOne.getMonth() + 1);
              } else {
                initMes = '' + Number(element.dateOne.getMonth() + 1);
              }
              dateInit = '' + element.dateOne.getFullYear() + initMes + initDay;
            } else {
              dateInit = '';
            }
          } else if (element.dateTwo) {
            if (element.dateTwo !== null && element.dateTwo !== undefined) {
              if (element.dateTwo.getDate() < 10) {
                endDay = '0' + element.dateTwo.getDate();
              } else {
                endDay = '' + element.dateTwo.getDate();
              }
              if (Number(element.dateTwo.getMonth() + 1) < 10) {
                endMes = '0' + Number(element.dateTwo.getMonth() + 1);
              } else {
                endMes = '' + Number(element.dateTwo.getMonth() + 1);
              }
              dateEnd = '' + element.dateTwo.getFullYear() + endMes + endDay;
            } else {
              dateEnd = '';
            }
          } else if (element.dateBirth) {
            if (element.dateBirth !== null && element.dateBirth !== undefined) {
              if (element.dateBirth.getDate() < 10) {
                initDay = '0' + element.dateBirth.getDate();
              } else {
                initDay = '' + element.dateBirth.getDate();
              }
              if (Number(element.dateBirth.getMonth() + 1) < 10) {
                initMes = '0' + Number(element.dateBirth.getMonth() + 1);
              } else {
                initMes = '' + Number(element.dateBirth.getMonth() + 1);
              }
              dateThree = '' + element.dateBirth.getFullYear() + initMes + initDay;
            } else {
              dateThree = '';
            }
          }
        });
        const retorno = {
          'dateTwo': dateEnd,
          'dateOne': dateInit,
          'dateThree': dateThree
        };
        resolve(retorno);
      }
    });
  }

  compareDates(dStart, dEnd): boolean {
    if ((!dEnd || !dStart || dStart <= dEnd) && (!this.endDateStorage || String(dEnd) !== String(this.endDateStorage))) {
      return true;
    } else if (String(dEnd) !== String(this.endDateStorage)) {
      this.notification.setWarning(this.translate.instant('FORM_EMPLEADO.ENDDATE_OVER_STARTDATE'));
      return false;
    } else {
      this.notification.setWarning(this.translate.instant('FORM_EMPLEADO.ENDDATE_EQUALS_NEW_ENDDATE'));
    }
  }

  onEmailEmployeeChange(target, event) {
    // tslint:disable-next-line:no-unused-expression
    const dat = this.modelForm.emailEmployee;
    if (target === 'emailEmployee' && this.modelForm.emailEmployee.substr(this.modelForm.emailEmployee.length - 1) === '@') {
      if (this.modelForm.emailEmployee.substring(0, this.modelForm.emailEmployee.indexOf('@')) &&
        !this.modelForm.emailEmployee.substring(0, this.modelForm.emailEmployee.indexOf('ciber')) && (
          event.inputType !== 'deleteContentBackward' && event.inputType !== 'deleteContentForward')) {
        this.modelForm.emailEmployee = this.modelForm.emailEmployee + 'ciberexperis.es';
      }
    }
  }

  selectDivision(intDivId) {
    if (intDivId) {
      this.subscriptions.push(
        this.employeesService.getDivisionGroups(intDivId).subscribe((data: any[]) => {
          if (data) {
            this.grupos = data;
            this.modelFormControlDisabled.intDivId = false;
          }
        }),
        this.employeesService.getResponsible(intDivId).subscribe((data: any[]) => {
          if (data) {
            this.responsables = data;
          }
        })
      );
    }
  }

  takeEmploye(empleado, form: NgForm) {
    this.endDateStorage = null;
    if (empleado.Id !== '') {
      this.employe = empleado;
      this.employeId = empleado.Id;
      if (form !== null) {
        this.resetFormulario(form);
        this.employeId = empleado.Id;
      }
      this.mostrarboton = true;
      this.textButton = this.translate.instant('MODNP');
      this.observatory.setData('textHeader', 'modify');
      this.subscriptions.push(
        this.employeesService.getEmployeeData(empleado.Id).subscribe(data => {
          if (data) {
            data.forEach(element => {
              // tslint:disable-next-line:forin
              for (const fieldName in element) {
                this.modelForm[fieldName] = element[fieldName];
                if (fieldName === 'intDivId') {
                  this.selectDivision(element[fieldName]);
                }
                // COMPROBAR SI LLEGA FECHA DE alta --> dar formato fecha al campo
                if (fieldName === 'registerDateEmployee') {
                  if (this.modelForm[fieldName]) {
                    const year = this.modelForm.registerDateEmployee.replace(/-/g, '').substring(0, 4);
                    const month = this.modelForm.registerDateEmployee.replace(/-/g, '').substring(4, 6);
                    const day = this.modelForm.registerDateEmployee.replace(/-/g, '').substring(6, 8);
                    this.modelForm.startDate = new Date(Number(year), Number(month) - 1, Number(day));
                  }
                }
                //  COMPROBAR SI LLEGA FECHA DE BAJA --> bloquear formulario y dar formato fecha al campo
                if (fieldName === 'endDateEmployee') {
                  if (this.modelForm[fieldName]) {
                    const year = this.modelForm.endDateEmployee.replace(/-/g, '').substring(0, 4);
                    const month = this.modelForm.endDateEmployee.replace(/-/g, '').substring(4, 6);
                    const day = this.modelForm.endDateEmployee.replace(/-/g, '').substring(6, 8);
                    this.modelForm.endDate = new Date(Number(year), Number(month) - 1, Number(day));
                    this.endDateStorage = new Date(Number(year), Number(month) - 1, Number(day));
                    this.modelFormControlDisabled.allLocked = true;
                    this.modelFormControlDisabled.intDivId = true;
                    this.modelFormControlDisabled.startDate = true;
                  }
                }
                //  COMPROBAR SI LLEGA FECHA DE Cumpleaños
                if (fieldName === 'birthEmployee') {
                  if (this.modelForm[fieldName]) {
                    const year = this.modelForm.birthEmployee.replace(/-/g, '').substring(0, 4);
                    const month = this.modelForm.birthEmployee.replace(/-/g, '').substring(4, 6);
                    const day = this.modelForm.birthEmployee.replace(/-/g, '').substring(6, 8);
                    this.modelForm.dateBirth = new Date(Number(year), Number(month) - 1, Number(day));
                  }
                }
              }
              this.staticSapId = this.modelForm.sapId;
              this.modelForm.emailEmployee = element.emailEmployee.trim();
            });
          }
        }),
        this.employeesService.getWorkingDayEmployee(empleado.Id).subscribe(data => {
          if (data) {
            if (!!data.length) {
              this.modelJornada = data;
              this.modelForm.intJorId = this.modelJornada[this.modelJornada.length - 1].intJorId;
              this.modelForm.varEmpjorComentario = this.modelJornada[this.modelJornada.length - 1].varJorComentario; // varEmpjorComentario;
            }
          }
        }),
        this.employeesService.getCategoryData(empleado.Id).subscribe(data => {
          if (data) {
            if (!!data.length) {
              this.modelCategoria = data;
              this.modelForm.intCatId = this.modelCategoria[this.modelCategoria.length - 1].intCatId;
            }
          }
        })
      );
      this.modelFormControlDisabled.sapId = true;
      this.modelFormControlDisabled.emailEmployee = true;
      if (this.isOperationsTypeUser) {
        this.modelFormControlDisabled.endDate = true;
      } else {
        this.modelFormControlDisabled.endDate = false;
      }
    } else {
      this.resetFormulario(form);
      this.textButton = this.translate.instant('CREMP');
      this.observatory.setData('textHeader', 'new');
      this.modelFormControlDisabled.allLocked = false;
      this.modelFormControlDisabled.intDivId = true;
      this.modelFormControlDisabled.startDate = false;
      this.modelFormControlDisabled.emailEmployee = false;
      this.modelFormControlDisabled.sapId = false;
      this.modelFormControlDisabled.endDate = true;
    }
  }

  resetFormulario(form: NgForm) {
    if (form) {
      form.reset();
    }
    // tslint:disable-next-line:forin
    for (const campo in this.modelForm) {
      this.modelForm[campo] = null;
    }
    this.divisionModel = null;
    this.panelCategoria = false;
    this.panelJornada = false;
    this.modelJornada = [];
    this.modelFormControlDisabled.intDivId = true;
    this.modelCategoria = [];
    this.mostrarboton = false;
    this.showIntExtButton = false;
  }

  convertDateToStringFormat(value, type) {
    const fecha = [
      { dateOne: value }
    ];
    if (type === 'category') {
      this.formatDates(fecha).then(
        (val: any) => {
          this.modelNewCategory.datEmpcatFechainicio = val.dateOne;
        }
      );
    }
    if (type === 'workingday') {
      this.formatDates(fecha).then(
        (val: any) => {
          this.modelNewWorkingDay.datEmpJorFechaInicio = val.dateOne;
        }
      );
    }
    if (type === 'birthEmployee') {
      this.formatDates(fecha).then(
        (val: any) => {
          this.modelForm.birthEmployee = val.dateOne;
        }
      );
    }
  }

  clearCategory() {
    this.panelCategoria = false;
    this.modelNewCategory = {
      intCatId: null,
      fechaCatInicio: null,
      datEmpcatFechainicio: null
    };
  }

  clearWorkingDay() {
    this.panelJornada = false;
    this.modelNewWorkingDay = {
      intJorId: null,
      fechaJorInicio: null,
      datEmpJorFechaInicio: null,
      varEmpjorComentario: null
    };
  }

  ngOnDestroy() {
    for (const subs of this.subscriptions) {
      subs.unsubscribe();
    }
  }

  gmailValidator() {
    return this.gmailFormControl.hasError('pattern') && !this.gmailFormControl.hasError('required');
  }

  changeIntExt() {
    // Create a copy of the model before any changes
    this.modelFormBeforeChangeIntExt = JSON.parse(JSON.stringify(this.modelForm));
    this.showIntExtButton = true;
    this.modelFormControlDisabled.sapId = false;
    this.modelFormControlDisabled.emailEmployee = false;
    this.modelForm.rateEmployee = this.modelForm.rateEmployee !== null ? this.modelForm.rateEmployee : '0.00';
    this.modelForm.externalEmployee = this.modelForm.externalEmployee ? 0 : 1;
  }

  cancelOption() {
    this.showIntExtButton = !this.showIntExtButton;
    this.modelFormControlDisabled.sapId = true;
    this.modelFormControlDisabled.emailEmployee = true;
    // Recover the model before changes
    this.modelForm = JSON.parse(JSON.stringify(this.modelFormBeforeChangeIntExt));
  }

  modifyEmployeType(employeetype) {
    this.modelForm['registerDateEmployee'] = this.datePipe.transform(this.modelForm['startDate'], 'yyyyMMdd');
    if (this.modelForm.rateEmployee !== null) {
      this.modelForm.rateEmployee = '' + this.modelForm.rateEmployee;
      this.modelForm.rateEmployee = this.modelForm.rateEmployee.trim();
      this.modelForm.rateEmployee = parseFloat(this.modelForm.rateEmployee).toFixed(2);
    } else {
      this.modelForm.rateEmployee = parseFloat('0').toFixed(2);
    }
    // employee type = 0 (external) > toIntern
    if (employeetype === 0) {
      this.employeesService.putIntEmployeType(this.modelForm, this.employeId).subscribe(res => {
        if (res.response === 'OK') {
          this.notification.setSuccess(this.translate.instant(`FORM_EMPLEADO.TYPE_EMPLOYE_${this.modelForm.externalEmployee}`));
          const value = this.modelForm.nameEmployee + ' ' + this.modelForm.surnamesEmployee;
        } else {
          this.notification.setWarning(this.translate.instant('ERRORS.' + res.response));
        }
        this.takeEmployeData(this.modelForm.emailEmployee);
        this.showIntExtButton = false;
      });
    }

    // employee type = 1 (external) > toExtern
    if (employeetype === 1) {
      this.employeesService.putExtEmployeType(this.modelForm, this.employeId).subscribe(res => {
        if (res.response === 'OK') {
          this.notification.setSuccess(this.translate.instant(`FORM_EMPLEADO.TYPE_EMPLOYE_${this.modelForm.externalEmployee}`));
          const value = this.modelForm.nameEmployee + ' ' + this.modelForm.surnamesEmployee;
          this.searchInput.value = value;
        } else {
          this.notification.setWarning(this.translate.instant('ERRORS.' + res.response));
        }
        this.takeEmployeData(this.modelForm.emailEmployee);
        this.showIntExtButton = false;
      });

    }
  }

  buttonSuccessValidation() {
    return !this.modelForm.startDate ||
           !this.modelForm.emailEmployee ||
           this.gmailValidator() ||
           !this.availableButton ||
           this.postalCodeFormControl.hasError('minlength') ||
           this.emailFormControl.hasError('pattern');
  }

  reactivate(form) {
    this.employeesService.reactiveEmploye(this.employeId).subscribe(res => {
      this.notification.setSuccess(this.translate.instant('FORM_EMPLEADO.EMPLOYE_REACTIVATE'));
      this.modelFormControlDisabled.allLocked = false;
      this.modelFormControlDisabled.endDate = true;
      this.modelFormControlDisabled.startDate = false;
      this.modelFormControlDisabled.intDivId = true;
      this.modelFormControlDisabled.sapId = false;
      this.modelFormControlDisabled.emailEmployee = false;
      this.takeEmployeData(this.modelForm.emailEmployee);
      this.resetFormulario(form);
    });
  }

  isSapIdValid() {
    return this.staticSapId === this.modelForm.sapId;
  }

  isValidEmail() {
    return !(this.modelForm.emailEmployee.indexOf('_OLD') > -1);
  }

  /**
   * Function to indicate if the selector type employee is disabled or not
   */
  isOtherDataTypeDisabled() {
    return this.employeId !== undefined;
  }
}
